<template>
  <div class="order_list">
    <!-- tab -->
    <div class="tabs" style="margin:0 25px;font-size:16px;">
      <div v-for="item in orderList"
           :key="item.key"
           :class="'order-tab-item '+(item.key===dataForm.orderStatus?'tab-item-active':'')"
           @click="changeStatusHandle(item.key)">
        {{item.lable}}
      </div>
    </div>
    <el-form :inline="true" :model="dataForm">
      <el-form-item label="订单编号：">
        <el-input v-model="dataForm.orderCode" placeholder="单据编号" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单类型：">
        <el-select v-model="dataForm.orderSource" placeholder="请选择" clearable>
          <el-option label="RDMS在线服务" value="60"></el-option>
          <el-option label="RDMS自助服务" value="80"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="制单时间：">
        <el-date-picker type="datetime" placeholder="选择日期" v-model="dataForm.startTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width:200px;display:inline-block"></el-date-picker>
        <span style="text-align:center;display:inline-block">-</span>
        <el-date-picker type="datetime" placeholder="选择时间" v-model="dataForm.endTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width:200px;display:inline-block"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="butt" type="primary" @click="getDataList(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataLoading"
              :data="dataList"
              border
              style="width: 100%; max-width: 100%;">
      <div class="no_show_message" slot="empty">
        <img src="@/assets/img/good/noGood.png" alt="暂无相关订单">
        <div>暂无相关订单</div>
      </div>
      <el-table-column type="index"
                        label="序号"
                        header-align="center"
                        align="center"
                        width="50"></el-table-column>
      <el-table-column prop="orderCode"
                        label="订单编号"
                        header-align="center"
                        width="110px"
                        align="center"></el-table-column>
      <el-table-column prop="orderStatus"
                        label="状态"
                        header-align="center"
                        align="center">
        <template slot-scope="scope">
          {{$getDictLabel('ORDER_STATUS', scope.row.orderStatus)}}
        </template>
      </el-table-column>
      <el-table-column prop="payMoney"
                        label="金额"
                        header-align="center"
                        align="center">
        <template slot-scope="scope">{{scope.row.payMoney|formatePrice}}</template>
      </el-table-column>
      <el-table-column prop="payStatus"
                        label="支付状态"
                        width="80px"
                        header-align="center"
                        align="center">
        <template slot-scope="scope">
          {{$getDictLabel('ORDER_PAY_STATUS', scope.row.payStatus)}}
        </template>
      </el-table-column>
      <el-table-column prop="orderSource"
                        label="订单类型"
                        header-align="center"
                        align="center">
        <template slot-scope="scope">
          {{$getDictLabel('ORDER_SOURCE', scope.row.orderSource)}}
        </template>
      </el-table-column>
      <el-table-column prop="createTime"
                        label="创建时间"
                        header-align="center"
                        align="center"></el-table-column>
      <el-table-column :label="$t('handle')"
                        header-align="center"
                        align="center"
                        width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="detailOrderHandle(scope.row)">查看详情</el-button>
          <el-button type="text" v-show="(Number(scope.row.orderStatus) || 0) === 20"
                     @click="cancelOrderHandle(scope.row)">取消</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="dataForm.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="dataForm.limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="getDataList">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataLoading: false,
      orderList: [
        {
          key: '0',
          lable: '全部'
        },
        {
          key: '20',
          lable: '待支付'
        },
        {
          key: '21',
          lable: '已上传凭证'
        },
        {
          key: '29',
          lable: '已确认收款'
        }
      ],
      dataForm: {
        page: 1,
        limit: 10,
        startTime: '',
        endTime: '',
        orderStatus: '0',
        orderCode: '',
        orderSource: ''
      },
      total: 0,
      dataList: []
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 获取列表数据
    getDataList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataForm.startTime = this.dataForm.startTime || ''
      this.dataForm.endTime = this.dataForm.endTime || ''
      this.dataLoading = true
      this.$http.get(`/front/consumer/fictitiousorder/myOrderList`, {
        params: this.dataForm
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = Number(res.data.total) || 0
          this.dataList = res.data.records || []
        })
        .catch(() => {
          // console.log(err)
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改当前订单查询状态
    changeStatusHandle (valueKey) {
      if (this.dataLoading) {
        return false
      }
      if (valueKey === this.dataForm.orderStatus) {
        return false
      }
      this.dataForm.orderStatus = valueKey
      this.dataForm.orderSource = ''
      this.dataForm.orderCode = ''
      this.dataForm.startTime = null
      this.dataForm.endTime = null
      this.getDataList(1)
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getDataList(1)
    },
    // 查看详情
    detailOrderHandle (row) {
      this.$router.push({
        name: 'rdmsOrderDetail',
        params: {
          id: row.orderId
        }
      })
    },
    // 取消订单
    cancelOrderHandle (row) {
      this.$confirm('是否取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataLoading = true
        this.$http.post(`/front/consumer/order/cancelOrder`, {
          orderId: row.orderId
        })
          .then(({ data: res }) => {
            this.dataLoading = false
            if (res.code === 0) {
              this.getDataList(1)
              this.$message.success(res.message)
            } else {
              return false
            }
          })
          .catch(() => {
            this.dataLoading = false
          })
      })
    },
    // 去支付
    goToPay (row) {
      this.$router.push({
        name: 'orderPay',
        query: {
          id: row.orderId,
          money: row.payMoney,
          virtualAccount: row.virtualAccount
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.order_list{
  .order-tab-item {
    display: inline-block;
    margin-left: 10px;
    text-align: center;
    background: #ffffff;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    letter-spacing: 0;
    margin-right: 24px;
    cursor: pointer;
  }
  .tab-item-active{
    color: #1D65A8;
    border-bottom: 2px solid #1D65A8;
  }
}
</style>
